import React from 'react';

// Small inline shield glyph shared by the partner-guard badge (Client Explorer table,
// Client Edit page) and the partner-guard row/dialog copy - kept as one component so
// every surface renders the exact same icon instead of each hand-rolling its own SVG.
const ShieldIcon = ({ checked = false, size = 13, color = 'currentColor', style }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    width={size}
    height={size}
    style={{ flex: 'none', display: 'inline-block', verticalAlign: '-2px', ...style }}
  >
    <path d="M12 3 5 6v6c0 5 3 8.5 7 9 4-.5 7-4 7-9V6l-7-3z" />
    {checked && <path d="m9 12 2 2 4-4" />}
  </svg>
);

export default ShieldIcon;
